export default "__VITE_ASSET__BWvX_Zxc__"